import { abyssColors } from '@/theme/colors';
import { Stack, Typography, styled as muiStyled } from '@mui/material';

export const Break = muiStyled(Stack)(() => ({
  width: '0.1rem',
  height: '3.8rem',
  background: abyssColors.primary[300],
}));

export const StatusChip = muiStyled(Stack)(() => ({
  padding: '0.6rem 1.2rem',
  borderRadius: '3.2rem',
}));

export const Status = muiStyled(Typography)(() => ({
  fontSize: '1.4rem',
  fontWeight: 500,
  lineHeight: 'normal',
}));
